/**
 * 配置不同环境接口前缀
 * 如果未配置dev为默认配置
 * @param {*} base
 * @example
 * {
 *   dev: 'dev环境配置信息',
 *   test: 'test环境配置信息',
 *   prod: '线上环境配置信息'
 * }
 */

function conf(base = {}) {
  if (process.env.ENV_CONFIG === "prod") {
    // 生产环境下
    return base["prod"];
  }
  if (process.env.ENV_CONFIG === "test") {
    return base["test"];
  }
  // 开发环境
  return base["dev"];
}

// PORTAL 接口打包用//https://www.seafoodlinker.com/api
//http://123.57.49.229/api

//测试47.95.124.243
//联通云112.91.137.76:2597
// 联通云测试 https://liantong.szitt.com.cn/api
//https://liantong.szitt.com.cn/api

export const POR_LOGIN_LOGOUT = conf({
  dev: "/api",
  test: "https://pc.goldbrick.seafoodlinker.com/api",
  prod: "https://pc.bricksfishery.seafoodlinker.com/api",
});



// WEBPACK FOOTER //
// ./src/request/config.js